import { useParams } from 'react-router-dom'
import { Container, LoadingOverlay, Paper } from '@mantine/core'

import { EventTitle } from '@/components/common/EventTitle'
import { EventDetail } from '@/components/Event/CourtReporterDetail/EventDetail'
import { Shell } from '@/components/Shell'
import { useCourtReporter } from '@/providers/UserProvider'
import { useCourtReporterEventQuery } from '@/queries/courtReporters'
import { EventLoadError } from '@/routes/Event/components/EventLoadError'
import { NotFound } from '@/routes/NotFound'

export const Event = () => {
  const { id } = useParams<{ id: string }>()
  const courtReporter = useCourtReporter()

  const {
    data: event,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useCourtReporterEventQuery(id, courtReporter!.id, {
    refetchInterval: 20000,
    refetchOnWindowFocus: true,
  })

  if (isLoading) {
    return (
      <Shell>
        <LoadingOverlay visible={true} />
      </Shell>
    )
  }

  if (error?.response?.status === 404) {
    return <NotFound text="Event not found" />
  }

  if (event === undefined) {
    return (
      <EventLoadError
        onRetry={() => {
          void refetch()
        }}
        isFetching={isFetching}
      />
    )
  }

  return (
    <Shell header={{ middle: <EventTitle>{event.name}</EventTitle> }}>
      <Container size="lg">
        <Paper p="xl">
          <EventDetail event={event} />
        </Paper>
      </Container>
    </Shell>
  )
}
